import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableColumn, TableViewComponentBase, TableViewFilter } from '../table-view-component-base';
import { diff } from 'deep-object-diff';


@Component({
    selector: 'fes-table-view-config',
    styleUrls: ['./table-view-config.component.scss'],
    templateUrl: './table-view-config.component.html'
})
export class TableViewConfigComponent {

    @Input('table') set tableSetter(table: TableViewComponentBase<any>){
        this.srcTable = table
        this.fieldConfigs = table.tableColumns.map(c=> ({
            column: c,
            filter: c.filter ? Object.assign({},c.filter) : null
        }))
        this.pageSize = table.pageSize
    }
    srcTable: TableViewComponentBase<any>

    @Output('filterKeyUp') filterKeyUp$ = new EventEmitter<{event:KeyboardEvent,filter:TableViewFilter}>()

    // form data
    fieldConfigs: { column: TableColumn, filter: TableViewFilter }[] = []
    pageSize: number

    @Input() pagingEnabled = true

    async onFilterModeChanged(column: TableColumn) {
        console.log(`onFilterModeChanged(${column.filter?.mode})`)
        //this.load()
    }

    onPageSizeChange(pageSize: number) {
        console.log(`onPageSizeChange(${this.pageSize})`)
    }

    isModified() {
        let bModified = false
        if ( this.pageSize != this.srcTable.pageSize ) {
            console.log(`Page size changed from ${this.srcTable.pageSize} to ${this.pageSize}`)
            bModified = true
        } else {
            for( const config of this.fieldConfigs.filter(config=>config.filter) ) {
                const filterDiff = diff(config.column.filter,config.filter)
                if ( Object.keys(filterDiff).length ) {
                    console.log(`filter ${config.column.name} changed:`)
                    console.dir(filterDiff)
                    bModified = true
                    break;
                }
            }
        }
        console.log(`isModified(): ${bModified}`)
        return bModified
    }

    async applyChanges() {
        this.fieldConfigs.forEach(config=>{
            if ( config.column.filter ) {
                config.column.filter=config.filter
            }
        })
        this.srcTable.pageSize = this.pageSize
    }
}